import {columnCls} from "./BoardColumnEl";
import {Button} from "@mui/material";
import {useContext} from "react";
import {BoardContext} from "./BoardContextProvider";

export function AddBoardColumn(props: {
    board: number;
}) {
    const ctx = useContext(BoardContext);

    return (
        <div className={columnCls} style={{
            padding: 16,
        }}>
            <Button variant="outlined" color="inherit" fullWidth onClick={() => {
                ctx.onShowColumn({
                    id: 0,
                    board: props.board,
                    title: "",
                    boardTitle: "",
                    completedColumn: false,
                    autoAddRule: {},
                    archived: false,
                    sortOrder: 9999,
                })
            }}>
                Add Column
            </Button>
        </div>
    )
}